export enum ReportInputTypeEnum {
  BOOKS = 'books',
  AUTHORS = 'authors',
}
